// 图纸父级类型
export enum DrawingManagementParentType {
  'drawDesc' = '图纸说明',
  'origin' = '原始类施工图',
  'unknit' = '拆改类施工图',
  'ground' = '地面类施工图',
  'top' = '顶面类施工图',
  'waterElectric' = '水电类施工图',
  'facade' = '立面类施工图',
  'other' = '其他类施工图',
  'source' = '源文件',
}

// 图纸子级类型
export interface DrawingManagementChildTypeMap {
  [key: string]: {
    name: string;
    required: boolean;
  };
}

export const DrawingManagementChildType: DrawingManagementChildTypeMap = {
  'drawDesc-Catalogue': { name: '图纸目录', required: true },
  'drawDesc-designDesc': { name: '设计说明', required: true },
  'drawDesc-drawDemlist': { name: '图例表', required: true },
  'drawDesc-desc': { name: '现场交底特殊情况说明', required: true },
  'drawDesc-desc1': { name: '常用家电尺寸规格建议', required: true },
  'origin-OriginalStructure': { name: '原始结构图', required: true },
  'origin-OriginalTop': { name: '原始顶面图', required: true },
  'origin-OriginalPeri': { name: '原始面积周长图', required: true },
  'unknit-WallDemolition': { name: '墙体拆除图', required: false },
  'unknit-WallNew': { name: '墙体新建图', required: false },
  'unknit-ReconstructionArea': { name: '改造后面积周长图', required: false },
  'unknit-OriginalConstruction': { name: '原始地面施工图', required: true },
  'ground-PlaneLayout': { name: '平面布置图', required: true },
  'ground-HomeMain': { name: '家具主材尺寸图', required: true },
  'ground-FloorCovering': { name: '地面铺装图', required: true },
  'top-topModelling': { name: '顶面造型图', required: true },
  'top-topSize': { name: '顶面造型尺寸图', required: true },
  'waterElectric-waterStrong': { name: '水电包标配强电点位图', required: true },
  'waterElectric-waterWeak': { name: '水电包标配强弱电点位图', required: true },
  'waterElectric-waterSwitch': { name: '开关布置图', required: true },
  'facade-restaurant': { name: '客餐厅立面图', required: false },
  'facade-kitchen': { name: '厨房展开立面图', required: false },
  'facade-TOILET': { name: '卫生间展开立面图', required: false },
  'facade-bedroom': { name: '卧室立面图', required: false },
  'other-disclose': { name: '开工交底单', required: false },
  'other-node': { name: '节点大样图', required: false },
  'other-staticState': { name: '静态效果图', required: false },
  'source-sourceFile': { name: '源文件', required: true },
};

// 锚点列表
export const anchorList = [
  {
    key: 'drawing-desc',
    href: '#drawing-desc',
    title: '图纸说明',
  },
  {
    key: 'drawing-origin',
    href: '#drawing-origin',
    title: '原始类施工图',
  },
  {
    key: 'drawing-demolition',
    href: '#drawing-demolition',
    title: '拆改类施工图',
  },
  {
    key: 'drawing-ground',
    href: '#drawing-ground',
    title: '地面类施工图',
  },
  {
    key: 'drawing-ceiling',
    href: '#drawing-ceiling',
    title: '顶面类施工图',
  },
  {
    key: 'drawing-electricity',
    href: '#drawing-electricity',
    title: '水电类施工图',
  },
  {
    key: 'drawing-elevation',
    href: '#drawing-elevation',
    title: '立面类施工图',
  },
  {
    key: 'drawing-other',
    href: '#drawing-other',
    title: '其他类施工图',
  },
  {
    key: 'drawing-source',
    href: '#drawing-source',
    title: '源文件',
  },
]
